
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inbox",
      function () {
        return require("private-next-pages/inbox/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inbox"])
      });
    }
  